import React, { useEffect, useState } from "react";
import "./SelectAddressComponent.css";
import SelectAddressCard from "../GrayBoxWithText/SelectAddressCard/SelectAddressCard";
import Action_Btn from "../../Common-Component/Common_Btn/Action_Btn/Action_Btn";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Black_Btn from "../../Common-Component/Common_Btn/Black_Btn/Black_Btn";
import CommonSelectAddress from "../../Common-Component/CommonSelectAddress/CommonSelectAddress";
import AddAddressModal from "../../Common-Component/Common_Modal/AddAddressModal/AddAddressModal";
import {
  getAllOrderAddress,
  getAllSippingOrderAddress,
  getSingleOrderAddress,
} from "../../../features/order/orderSlice";
import { useDispatch, useSelector } from "react-redux";

const SelectAddressComponent = ({
  billingAddressId,
  setBillingAddressId,
  shippingAddressId,
  setShippingAddressId,
  setShowOrderSummary,
}) => {
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [active, setactive] = useState(false);
  const [type, setType] = useState("");

  const address = useSelector((state) => state.order.allOrdersAddress);
  const shippingAddressdata = useSelector(
    (state) => state.order.allSppingOrdersAddress
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllOrderAddress());
    dispatch(getAllSippingOrderAddress());
  }, [dispatch]);
  const [sameshippingBilling, setSameShippingBilling] = useState(false);
  useEffect(() => {
    setShippingAddressId(shippingAddressdata.data?.data[0]?.id);
  }, [shippingAddressdata]);

  const handleCheckboxClick = (event) => {
    if (event.target.checked) {
      setBillingAddressId(shippingAddressId); // If checked, set billing address to shipping address
    } else {
      setBillingAddressId(null); // If unchecked, set it to null
    }
    
    setSameShippingBilling(event.target.checked);
  };
  

 

  const [billingData, setBillingData] = useState();
  const [shippingData, setShippingData] = useState(false);
  const billingDataFinal = useSelector((state) => state.order.orderAddress);
  const GetDataBilling = async (id) => {
    try {
      const res = await dispatch(getSingleOrderAddress(id));
      setBillingData(res?.payload?.data);
    } catch (error) {}
  };

 
 
  
  // useEffect(() => {
  //   GetData(billingAddress);
  // }, [billingAddress]);

  const GetDataShipping = async (id) => {
    try {
      const res = await dispatch(getSingleOrderAddress(id));
      setShippingData(res?.payload?.data);
    } catch (error) {}
  };
  // useEffect(() => {
  //   GetDataShipping(shippingAddress);
  // }, [shippingAddress]);

  
  const isDisabled = !billingAddressId;
  
  return (
    <section className="SelectAddressComponent">
      <p className="heading_text">Select Address</p>
      {!active && (
        <>
          <div className="row">
            <div className="col-xl-6 col-lg-12">
              <div className="shipping_address_holder">
                {shippingAddressdata?.data?.data?.length > 0 &&
                  shippingAddressdata.data.data?.map((val, index) => (
                    <SelectAddressCard
                      name="Biiling"
                      index={index}
                      val={val}
                      setShippingAddressId={setShippingAddressId}
                    />
                  ))}

                <div
                  className="add_adress"
                  onClick={() => {
                    setShowAddressModal(true);
                    setType("Shipping Information");
                  }}
                >
                  <Action_Btn btn_name="Add Shipping Address" icon={faPlus} />
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-lg-12">
              <div className="shipping_address_holder">
                {address?.data?.data?.length > 0 &&
                  address.data.data?.map((val, index) => (
                    <SelectAddressCard
                      sameshippingBilling={sameshippingBilling}
                      setBillingAddressId={setBillingAddressId}
                      setSameShippingBilling={setSameShippingBilling}
                      billingAddressId={billingAddressId}
                      key={val.id}
                      val={val}
                      index={index}
                      addressType="Select Billing Address"
                    />
                  ))}

                <div
                  className="add_adress"
                  onClick={() => {
                    setShowAddressModal(true);
                    setType("Billing Information");
                  }}
                >
                  <Action_Btn btn_name="Add Billing Address" icon={faPlus} />
                </div>

                <div className="checkbox_div">
                  <Form.Check
                    type="checkbox"
                    id="agree"
                    name="nameRadio"
                    label="Same as shipping address"
                    checked={sameshippingBilling}
                    onChange={handleCheckboxClick}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="footer_part">
            {/* <div
              className="use_this_btn"
              onClick={() => {
                setactive(true);
                setShowOrderSummary(true);
                GetDataShipping(shippingAddressId);
                GetDataBilling(billingAddressId);
              }}
            >
              <Black_Btn btnText="Use This Address" />
            </div> */}
            <div
              className="use_this_btn"
              onClick={() => {
                if (!isDisabled) {
                  setactive(true);
                  setShowOrderSummary(true);
                  GetDataShipping(shippingAddressId);
                  GetDataBilling(billingAddressId);
                }
              }}
              style={{
                pointerEvents: isDisabled ? "none" : "auto",
                opacity: isDisabled ? 0.5 : 1,
              }}
            >
              <Black_Btn btnText="Use This Address" />
            </div>
          </div>
        </>
      )}

      {active && (
        <>
          {" "}
          <div className="get_address_div">
            <p className="address_type_text">Shipping Address</p>
            <CommonSelectAddress isChange={true} Data={billingData} />
          </div>
          <div className="footer_part">
            <hr></hr>

            <div className="billing_address_div">
              <p className="address_type_text">Billing Address</p>
              {sameshippingBilling ? (
                <div className="checkbox_div">
                  <Form.Check
                    type="checkbox"
                    id="agree"
                    label="Same as shipping address"
                    checked={sameshippingBilling}
                    disabled
                    // onChange={() => setSameShippingBilling(false)}
                  />
                </div>
              ) : (
                <CommonSelectAddress
                  isChange={true}
                  Data={billingData}
                />
              )}

              {/* <CommonSelectAddress
                isChange={true}
                shippingData={shippingData}
              />
              <div className="checkbox_div">
                <Form.Check
                  type="checkbox"
                  id="agree"
                  label="Same as shipping address"
                />
              </div> */}
            </div>
          </div>
        </>
      )}

      <AddAddressModal
        type={type}
        show={showAddressModal}
        onHide={() => {
          setShowAddressModal(false);
        }}
      />
    </section>
  );
};

export default SelectAddressComponent;
